import React, { Component } from 'react';
import { Union } from './Union.js';
import '../styles/style.css';

export class Period extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hide: true
        };
    }

    getUnions(unions) {
        let unionsArr = [];

        for (let i = 0; i < unions.length; i++) {
            if (unions[i].branches !== undefined && unions[i].branches.length > 0) {
                unionsArr.push(<Union key={unions[i].name + i} name={unions[i].name} branches={unions[i].branches} period={this.props.year + ":" + this.props.month} />);
            }
            if (unions[i].areas !== undefined && unions[i].areas.length > 0) {
                unionsArr.push(<Union key={unions[i].name + i} name={unions[i].name} unionareas={unions[i].areas} period={this.props.year + ":" + this.props.month} />);
            }
        }

        return unionsArr;
    }

    getMonthName(monthNumber) {
        const monthNames = ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'];

        return monthNames[monthNumber - 1];
    }

    render() {
        return (
            <div className='period-container'>
                <div className={this.state.hide ? "period-hide" : "period-show"}>
                    <div onClick={() => { this.setState({ hide: !this.state.hide }); }}>
                        <h3>{this.props.year} {this.getMonthName(this.props.month)}</h3>
                    </div>
                    <div> {this.getUnions(this.props.unions)} </div>
                </div>
            </div>
        );
    }
}